module.exports = __webpack_public_path__ + "media/images/countrysquared/af-a90007071902fec9216f60b01041b166.svg";